import create from './createAction'

export const SET_PROMOCODE_VALUE = 'SET_PROMOCODE_VALUE'
export const INIT_PROMOCODE_SESSION = 'INIT_PROMOCODE_SESSION'
export const RESET_PROMOCODE_SESSION = 'RESET_PROMOCODE_SESSION'
export const UPDATE_PROMOCODE_SESSION = 'UPDATE_PROMOCODE_SESSION'
export const ADD_PROMOCODE = 'ADD_PROMOCODE'
export const REMOVE_PROMOCODE = 'REMOVE_PROMOCODE'
export const UPDATE_PROMOCODE = 'UPDATE_PROMOCODE'
export const VALIDATE_PROMOCODE = 'VALIDATE_PROMOCODE'
export const PROMOCODE_ERROR = 'PROMOCODE_ERROR'

export const setPromoCodeValue = create(SET_PROMOCODE_VALUE)
export const initPromoCodeSession = create(INIT_PROMOCODE_SESSION)
export const resetPromoCodeSession = create(RESET_PROMOCODE_SESSION)
export const updatePromoCodeSession = create(UPDATE_PROMOCODE_SESSION)
export const addPromoCode = create(ADD_PROMOCODE)
export const removePromoCode = create(REMOVE_PROMOCODE)
export const updatePromoCode = create(UPDATE_PROMOCODE)
export const validatePromoCode = create(VALIDATE_PROMOCODE)
export const promoCodeError = create(PROMOCODE_ERROR)
